import React, { Component, } from "react";
import "@succ/views/App.scss";
import TwApp from '@succ/views/TwApp';
import IdApp from '@succ/views/IdApp';
import ThApp from '@succ/views/ThApp';
// import VnApp from '@succ/views/VnApp';
import PhApp from '@succ/views/PhApp';
import EmptyApp from './AppEmpty';

class App extends Component {
  render() {
    const componentMap = {
      tw: TwApp,
      id: IdApp,
      th: ThApp,
      vn: EmptyApp,
      ph: PhApp
    };

    const Comp = componentMap[process.env.REACT_APP_COUNTRY];

    return Comp ? React.createElement(Comp) : null;
  }
}

export default App;
